Object.defineProperty(exports,"__esModule",{value:true});exports.VictoryPie=undefined;var _victoryPie=require("./components/victory-pie");var _victoryPie2=_interopRequireDefault(_victoryPie);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.
VictoryPie=_victoryPie2.default;


//////////////////
// WEBPACK FOOTER
// ./~/victory-pie/lib/index.js
// module id = 1399
// module chunks = 0